module.exports = __webpack_public_path__ + "media/bg_home_g.b6417907.mp4";